import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFilaComponent } from './simple-icons-fila.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFilaComponent ],
    exports:      [ SimpleIconsFilaComponent ],
    bootstrap:    []
})
export class SimpleIconsFilaModule {}
